
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "76a5f02df600f81561ffad3e71ff81dbb35831f6",
  "nuxt": {
    "buildId": "0c275cce-2cc3-4c5c-8c31-8f4247146937"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
